/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiPredictionTypeFromJSON, ApiPredictionTypeToJSON, } from './ApiPredictionType';
import { ApiRetentionStatusFromJSON, ApiRetentionStatusToJSON, } from './ApiRetentionStatus';
export function ApiUserActionRetentionFromJSON(json) {
    return ApiUserActionRetentionFromJSONTyped(json, false);
}
export function ApiUserActionRetentionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'status': !exists(json, 'status') ? undefined : ApiRetentionStatusFromJSON(json['status']),
        'type': !exists(json, 'type') ? undefined : ApiPredictionTypeFromJSON(json['type']),
    };
}
export function ApiUserActionRetentionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'status': ApiRetentionStatusToJSON(value.status),
        'type': ApiPredictionTypeToJSON(value.type),
    };
}
